export default "__VITE_ASSET__c3e25828__"